// config.js
const apiUrl = 'https://serverfinal-n1ys.onrender.com'; // Replace with your actual API base URL
export default apiUrl;
   
